module.exports = __webpack_public_path__ + "01_mid_grey.9127f0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_mid_grey.png
// module id = JdCp
// module chunks = 0